/**
 * PORT-10
 * СЕРВИС: Сообщение об ошибке
 * Блок: Контент
 * Раздел: Документация
 * TODO: Отправка ошибки в JIRA
 * TODO: Отправка ошибки на почту администратору
 **/
import "./send_error.css"
import {POST, win_with, _t} from "../function.js";
let selectionBlock = null;

$('#block-main').attr("data-long-press-delay", "500")

document.addEventListener('long-press', function(event) {
    dialog(event.detail.pageX, event.detail.pageY)
});




/**
 * Событие выделение текста
 */
$('#block-main').on('mouseup', function (event) {
    dialog(event.pageX, event.pageY)
});
/**
 * Диалог с выделением об ошибке
 */
function dialog(X, Y){
    if (window.config.auth.code!==0) {
        return false;
    }

    if (window.getSelection().toString()) {
        const selectedText = window.getSelection().toString();
        window.selectedText = selectedText
        if (selectionBlock) {
            selectionBlock.remove();
        }
        selectionBlock = $(`
<div class="selection-block">
<div class="selection-block-text">${selectedText}</div>
<small>${_t('Нашли ошибку в выделенном тексте?')} 
<br><button class="v-btn send_error_text send_error_btn" onClick="formSend()">${_t('Отправить сообщение об ошибке')}</button> 
</div>`);
        selectionBlock.css({
            position: 'absolute',
            top: Y + 25 + 'px',
            left: X + 'px',
            zIndex: '89'
        });
        $("body").append(selectionBlock);
    } else {
        if (selectionBlock) {
            selectionBlock.remove();
            selectionBlock = null;
        }
    }
}

/**
 * Глобальная функция вывзова формы
 * регистрации ошибки с передачей текущей ссылки и выделеного текста
 */
window.formSend = () => {
    $$("win_err").show()
    $$("form_err").setValues({
        text_doc: window.selectedText,
        link: window.location
    })
}

/**
 * Форма регистрации ошибки в документации
 */
jqueryts.ui({
    view: "window",
    id: "win_err",
    css: "win_err bg",
    width: win_with,
    move: true,
    position: "center",
    head: {
        padding: 20,
        view: "toolbar",
        elements: [
            {
                view: "label",
                label: _t("Сообщение об ошибке"),
                css: "v-header"
            },
            {
                view: "icon", icon: "wxi-close", click: function () {
                    $$("win_err").hide();
                }
            }
        ]
    },
    body: {
        rows: [
            {
                id: "form_block_err",
                rows: [
                    {
                        view: "form",
                        id: "form_err",
                        rules: {
                            "text_doc": jqueryts.rules.isNotEmpty
                        },
                        elements: [
                            {
                                view: "textarea",
                                height: 100,
                                label: _t("Текст ошибки"),
                                labelPosition: "top",
                                name: "text_doc",
                                requare: true,
                            },
                            {
                                view: "textarea",
                                height: 100,
                                label: _t("Комментарий к ошибке"),
                                labelPosition: "top",
                                name: "comment"
                            },
                            {
                                view: "slider",
                                label: _t("Важность"),
                                value: "0",
                                step: 20,
                                name: "priority",
                                title: function (obj) {
                                    switch (obj.value) {
                                        case 0:
                                            return _t("Незначительная")
                                        case 20:
                                            return _t("Низкая")
                                        case 40:
                                            return _t("Средняя")
                                        case 60:
                                            return _t("Высокая")
                                        case 80:
                                            return _t("Срочная")
                                        case 100:
                                            return _t("Критическая")
                                    }
                                    return "..."
                                }
                            },
                            {
                                view: "text",
                                label: _t("Ссылка на страницу"),
                                labelPosition: "top",
                                name: "link",
                                disabled: true,
                            },
                        ],
                        borderless:true,
                    },
                    {
                        borderless:true,
                        padding: 20,
                        cols: [
                            {},
                            {
                                view: "button",
                                css: "v-btn-ts-md",
                                value: _t("Отмена"),
                                width: 120,
                                click: () => {
                                    $$("win_err").hide()
                                }
                            },
                            {
                                width: 20
                            },
                            {
                                view: "button",
                                css: "v-btn-ts-md",
                                width: 120,
                                value: _t("Отправить"),
                                click: () => {
                                    send_err()
                                }
                            }
                        ]
                    }
                ],
            },
            {
                template: `<div style="padding: 20px">#succ#</div>`,
                data: {succ: "..."},
                id: 'err_send_success',
                css: "err_send_success",
                autoheight: true,
                borderless: true,
                hidden: true,
            },
        ],
    },
    on:{
        onShow: function (){
            $$("form_block_err").show()
            $$("err_send_success").hide()
        }
    }
});


/**
 * Обработка отправки данных об ошибке на сервере
 * @returns {boolean|*}
 */
function send_err() {
    if (!$$("form_err").validate()) {
        return false
    }
    const form = $$("form_err").getValues()
    const id_user = window.config.auth.id_user
    if (id_user === undefined) {
        jqueryts.message({
            text: "Пользователь не определен.",
            type: "error"
        })
        return false
    }

    return POST("errors", {
        text_doc: form.text_doc,
        link: form.link,
        comment: form.comment,
        id_user: id_user,
        priority: form.priority
    }, 'report').then(res => {
        $$("form_block_err").hide()
        $$("err_send_success").show()
        $$("err_send_success").setValues({succ: _t("Сообщение об ошибке успешно отправлено")})
    })
}




